import { Link } from "react-router-dom";
import { ShieldCheck, Clock, User, Mail, Phone, XCircle, ArrowLeft, Share2 } from "lucide-react";
import { toast } from "sonner";

const POINTS = [
  { icon: User, title: "Código personalizado", desc: "Cada código se emite con el nombre, apellido, email y teléfono de la persona a quien se le otorga." },
  { icon: Clock, title: "Válido solo el mismo día", desc: "El descuento únicamente puede usarse el día en que se solicita y se entrega." },
  { icon: ShieldCheck, title: "Solicitado directamente a Carlos", desc: "Mis agentes me representan de forma directa y me solicitan a mí el código de descuento." },
  { icon: XCircle, title: "No reutilizable", desc: "Si no se usa ese mismo día, el código se pierde y no se puede volver a usar." },
];

const AvisoCodigosPage = () => {
  const shareWhatsApp = () => {
    const url = typeof window !== "undefined" ? window.location.href : "";
    const text = `AVISO IMPORTANTE — Cómo funcionan los códigos de descuento de Club Viajemos / Travel Empire: ${url}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Enlace copiado");
    } catch {
      toast.error("No se pudo copiar el enlace");
    }
  };

  return (
    <div data-testid="aviso-codigos-page" className="min-h-screen bg-[#0a0e1a]">
      <header className="border-b border-white/10 sticky top-0 z-50 bg-[#0a0e1a]/95 backdrop-blur">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-1 text-slate-400 hover:text-white text-sm font-medium">
            <ArrowLeft className="h-4 w-4" /> Inicio
          </Link>
          <span className="text-sm font-bold text-white">Club<span className="text-[#45A0EE]">Viajemos</span></span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#1a1408] via-[#13132a] to-[#1a1a2e] border-2 border-amber-400/40 p-6 sm:p-9">
          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-amber-400/15 blur-3xl pointer-events-none" />

          <div className="relative text-center mb-8">
            <div className="inline-flex items-center gap-2 bg-amber-400/15 border border-amber-400/40 rounded-full px-4 py-1.5 mb-4">
              <ShieldCheck className="h-4 w-4 text-amber-300" />
              <span className="text-amber-300 text-[11px] font-black uppercase tracking-[2px]">Aviso oficial</span>
            </div>
            <h1 className="text-2xl sm:text-3xl font-black text-white leading-tight mb-3">
              Cómo funcionan los <span className="text-amber-300">códigos de descuento</span>
            </h1>
            <p className="text-slate-300 text-sm sm:text-base max-w-xl mx-auto leading-relaxed">
              Para que estés 100% seguro de que el descuento que te ofrece tu agente es <strong className="text-white">real y oficial</strong>, así funciona el sistema:
            </p>
          </div>

          <div className="relative grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
            {POINTS.map((p) => (
              <div key={p.title} className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl p-4">
                <div className="w-10 h-10 rounded-lg bg-amber-400/15 flex items-center justify-center flex-shrink-0">
                  <p.icon className="h-5 w-5 text-amber-300" />
                </div>
                <div className="min-w-0">
                  <p className="text-white font-bold text-sm leading-snug">{p.title}</p>
                  <p className="text-slate-400 text-xs leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="relative bg-white/5 border border-white/10 rounded-xl p-5 mb-8">
            <div className="flex flex-wrap items-center justify-center gap-4 text-slate-300 text-xs sm:text-sm">
              <span className="flex items-center gap-1.5"><User className="h-4 w-4 text-amber-300" /> Nombre y apellido</span>
              <span className="flex items-center gap-1.5"><Mail className="h-4 w-4 text-amber-300" /> Email</span>
              <span className="flex items-center gap-1.5"><Phone className="h-4 w-4 text-amber-300" /> Teléfono</span>
            </div>
            <p className="text-center text-[11px] text-slate-500 mt-3">
              Todo código de descuento viene identificado con estos datos del cliente que lo recibe.
            </p>
          </div>

          <p className="relative text-center text-slate-400 text-sm mb-6 italic">
            "Mis agentes me representan de forma directa. Por eso cada descuento es verificable, personalizado y válido únicamente el mismo día."
            <br />
            <span className="text-white font-bold not-italic">— Carlos Miami Fernández · Club Viajemos / Travel Empire</span>
          </p>

          <div className="relative flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={shareWhatsApp}
              data-testid="aviso-share-whatsapp"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1eb955] text-white font-bold px-5 py-3 rounded-xl text-sm uppercase tracking-wide transition-colors"
            >
              <Share2 className="h-4 w-4" /> Compartir por WhatsApp
            </button>
            <button
              type="button"
              onClick={copyLink}
              data-testid="aviso-copy-link"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 border border-white/15 text-white font-bold px-5 py-3 rounded-xl text-sm uppercase tracking-wide transition-colors"
            >
              Copiar enlace
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AvisoCodigosPage;
